const initialState = () => ({
  installationTarget: null,
  selectedCorpId: null,
  corporationOption: [],
  adoptionInstallFilters: [{
    key: 'techs',
    active: false,
    label: 'All Technicians',
    options: [],
    activeOption: {},
  }, {
    key: 'isVerified',
    active: false,
    label: 'All Installs',
    options: [
      {
        label: 'All Installs',
        value: 'all',
      },
      {
        label: 'Verified Install',
        value: true,
      },
      {
        label: 'Unverified Install',
        value: false,
      },
      {
        label: 'Pending Verification',
        value: 'pending',
      },
    ],
    activeOption: {},
  },
  {
    key: 'nameplate',
    active: false,
    label: 'Nameplate',
    options: [
      {
        label: 'Profiled',
        value: 'profiled',
      },
      {
        label: 'Not profiled',
        value: 'notProfiled',
      },
    ],
    activeOption: {},
  },
  {
    key: 'installDate',
    active: false,
    label: 'Install Date',
    options: [
      {
        label: 'Last 7 Days',
        value: 'lastWeek',
      },
      {
        label: 'Last 30 Days',
        value: 'lastMonth',
      },
      {
        label: 'Last 365 Days',
        value: 'lastYear',
      },
    ],
    activeOption: {},
  }],
  technicians: [],
  loadingTechs: false,
});

export default initialState;
